import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenService } from '@core/services';
import { GlobalFacadeService } from '@store/facades';


export const securityGuardFn: CanActivateFn = () => {
  const router = inject(Router);

  const tokenService = inject(TokenService);
  const globalFacade = inject(GlobalFacadeService);

  if (!tokenService.isValidToken()) {
    const containsDesktop = globalFacade.useDesktop()
    const containsTokenSeller = tokenService.isValidTokenSeller();

    if (containsTokenSeller) {
      return router.createUrlTree(['/login'], { queryParams: { desktop: containsDesktop } });
    }

    return router.createUrlTree([''], { queryParams: { desktop: containsDesktop } })
  }

  return true;
}
